<template>
  <section class="system">
    <div class="container">
      <img class="system__img --fade-in-up" data-vertical-ivp-class="--animate" src="~@/assets/invest/GSTSystemRender.png" alt="">
      <CTA :showOffering="showOffering"/>
    </div>
  </section>
</template>

<style lang="scss" scoped>
  @import '@/styles/components/system.scss';
</style>

<script>
import CTA from '../components/cta.vue';

export default {
  name: 'System',
  data() {
    return {
      showOffering: false
    };
  },
	components: {
		CTA
	}
};
</script>

